var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "base-input",
      class: {
        "base-input--invalid": _vm.invalid,
        "base-input--has-prefix": _vm.prefix,
        "base-input--has-suffix": _vm.suffix && !_vm.suffixIsIcon,
        "base-input--has-suffix-icon": _vm.suffixIsIcon,
        "base-input--onfocus-hide-placeholder": _vm.hidePlaceholderOnFocus,
        "base-input--onfocus-hide-suffix": _vm.hideSuffixOnFocus,
        "base-input--hide-spin": _vm.hideSpin,
        "base-input--filter-style": _vm.filterStyle,
        "base-input--table-style": _vm.tableStyle
      }
    },
    [
      _vm.prefix
        ? _c("span", { staticClass: "base-input__prefix" }, [
            !_vm.prefixIsIcon
              ? _c("span", [
                  _vm._v("\n            " + _vm._s(_vm.prefix) + "\n        ")
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _c(
        "textarea",
        _vm._g(
          _vm._b(
            {
              ref: "input",
              staticClass: "base-input__input",
              attrs: {
                id: _vm.id,
                type: _vm.$attrs.type || "text",
                "aria-invalid": _vm.invalid,
                "aria-describedby": _vm.id + "_error",
                autocomplete: "none"
              },
              on: {
                input: function(event) {
                  _vm.$emit("update:value", event.target.value)
                  _vm.$emit("input", event.target.value)
                },
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return $event.stopPropagation()
                },
                blur: function(event) {
                  return _vm.$emit("blur", event)
                }
              }
            },
            "textarea",
            _vm.$attrs,
            false
          ),
          _vm.inputListeners
        )
      ),
      _vm.suffix
        ? _c(
            "label",
            {
              staticClass: "base-input__suffix",
              class: { "base-input__suffix--icon": _vm.suffixIsIcon },
              attrs: { for: _vm.id }
            },
            [
              !_vm.suffixIsIcon
                ? _c("span", [
                    _vm._v("\n            " + _vm._s(_vm.suffix) + "\n        ")
                  ])
                : _vm._e(),
              _vm.suffix === "icon-calendar"
                ? _c("svg", { attrs: { width: "19", height: "19" } }, [
                    _c("use", { attrs: { "xlink:href": "#calendar" } })
                  ])
                : _vm._e(),
              _vm.suffix === "icon-edit"
                ? _c("svg", { attrs: { width: "19", height: "19" } }, [
                    _c("use", { attrs: { "xlink:href": "#pencil" } })
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm.invalid
        ? _c("i", { staticClass: "base-input__error-icon" })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }